// extracted by mini-css-extract-plugin
module.exports = {"ModalSimpleContent__title":"ModalSimpleContent_ModalSimpleContent__title__z8syU"};